import React from 'react';
import PropTypes from 'prop-types';
import useIsWideScreen from '@medflex/hooks/useIsWideScreen';
import Modal from '../Modal';
import Badge, { KINDS } from '../Badge';

const FeatureUpgradeModal = ({ title, onClose, children, img }) => {
  const isWideScreen = useIsWideScreen();

  return (
    <Modal showCloseButton onClickOutside={onClose} onClickCloseButton={onClose}>
      <div data-component="FeatureToggle__SessionMeetingGroup" className="flex flex-col">
        <Badge className="mb-2 w-min" kind={KINDS.SIGNAL}>
          Upgrade
        </Badge>
        <h2 className="font-semibold mb-4 text-3xl">{title}</h2>
        <div className={img && isWideScreen ? 'mb-12' : ''}>{children}</div>
        {img && isWideScreen && (
          <img className="self-end" src={img} alt="Feature Toggle Teaser Bild" width="300" />
        )}
      </div>
    </Modal>
  );
};

FeatureUpgradeModal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  img: PropTypes.string,
};

FeatureUpgradeModal.defaultProps = {
  onClose: () => {},
};

export default FeatureUpgradeModal;
